export default function() {
  this.setState({
    loginError: undefined,
    loadingDataForInviteTokenError: undefined,
  })
}
